import { useMemo } from 'react';
import { AsYouType } from 'libphonenumber-js';

interface PhoneNumberProps {
  value: string;
}

export function PhoneNumber({ value }: PhoneNumberProps) {
  const formatted = useMemo(() => {
    const formatter = new AsYouType('US');
    return formatter.input(value);
  }, [value]);
  return <>{formatted}</>;
}
